import View from './View';

class ShowView extends View {
    constructor(name) {
        super(name);
        this._type = 'ShowView';
    }
}

export default ShowView;



// WEBPACK FOOTER //
// ./app/components/common/configuration/View/ShowView.js